const filterGroup = (() => {    
    const initBlock = el => {
        const content = el.querySelector('[data-filter-group-content]');
        el.querySelectorAll('[data-filter-group-toggle]').forEach(filterGroup => {
            filterGroup.addEventListener('click', () => {
                el.classList.toggle('filter-group--closed');
                content.classList.toggle('filter-group__wrapper--open');
            });
        });
        if (el.dataset.filterGroup === "checkboxes"){
            handleCheckboxes(el);
        }
        if (el.dataset.filterGroup === "radios"){
            handleRadios(el);
        }
        if (el.dataset.filterGroup === "mixed"){
            handleMixed(el);
        }
    };

    const refreshLocationArea = el => {        
        const selected = el.querySelector('[data-filter-selected]');
        const input = el.querySelector('[data-radio-input]');
        const select = el.querySelector('[data-radio-select]');
        const radio = el.querySelector('[data-radio] input:checked').closest("[data-radio]");
        
        input.classList.add('form-group--hidden');
        select.classList.add('form-group--hidden');
        if (radio.hasAttribute('data-has-input')){
            const inputField = input.querySelector('input');
            const radioInput = radio.querySelector('input');
            const labelField = el.querySelector('label[for="townPostcode"]');
            if (radioInput.value === 'postcode'){
                labelField.innerHTML = 'Postcode';
            } else {
                labelField.innerHTML = 'Town or city';
            }
            input.classList.remove('form-group--hidden');
            if (inputField.value.length > 0){
                selected.innerHTML = radio.dataset.radio.replace('###', inputField.value);
            } else {
                selected.innerHTML = radio.dataset.radio.replace('(###)', "");
            }            
        }
        else {
            selected.innerHTML = radio.dataset.radio;
        }
        
        if (radio.hasAttribute('data-has-select')){
            select.classList.remove('form-group--hidden');
        }
    }

    const refreshCheckboxesUi = el => {
        const selected = el.querySelector('[data-filter-selected]');
        const checkboxes = Array.from(el.querySelectorAll('[data-checkbox]'));
        const numSelected = checkboxes.filter(x => x.querySelector("input").checked).length;
        
        if (!numSelected && selected.dataset.filterZeroSelected) {
            selected.innerHTML = selected.dataset.filterZeroSelected;
        }
        else if (numSelected && selected.dataset.filterSomeSelected) {
            selected.innerHTML = selected.dataset.filterSomeSelected;
        }
        else if (el.querySelector("[data-checkbox-all] input:checked")) {
            selected.innerHTML = el.querySelector("[data-checkbox-all] .flag-wrap__flag__text").innerHTML;
        } 
        else {
            selected.innerHTML = `${checkboxes.filter(x => x.querySelector("input").checked).length} selected`;    
        }
    }

    const refreshRadiosUi = el => {
        const selected = el.querySelector('[data-filter-selected]');
        const selectedRadio = el.querySelector('[data-radio] input:checked');

        selected.innerHTML = selectedRadio ? selectedRadio.closest("[data-radio]").dataset.radio : "Any";
    }

    const refreshUi = () => {
        document.querySelectorAll("[data-filter-group]")
            .forEach(scope => {
                if (scope.dataset.filterGroup === "checkboxes"){
                    refreshCheckboxesUi(scope);
                }
                if (scope.dataset.filterGroup === "radios"){
                    refreshRadiosUi(scope);
                }
                if (scope.dataset.filterGroup === "mixed"){
                    refreshLocationArea(scope);
                }  
            });
    }

    const handleCheckboxes = el => {
        const checkboxes = Array.from(el.querySelectorAll('[data-checkbox]'));
        const allCheckbox = el.querySelector('[data-checkbox-all]');
        
        checkboxes.forEach(checkbox => {
            const input = checkbox.querySelector('input');
            input.addEventListener('input', () => {
                if (allCheckbox) {
                    allCheckbox.querySelector("input").checked =  checkboxes.filter(x => x.querySelector("input").checked).length === checkboxes.length;
                }

                refreshCheckboxesUi(el);
            });
        });
        
        if (allCheckbox){
            const allCheckboxInput = allCheckbox.querySelector('input');
            allCheckboxInput.addEventListener('input', () => {
                checkboxes.forEach(x => x.querySelector("input").checked = allCheckboxInput.checked);

                refreshCheckboxesUi(el);
            });            
        }
    };

    const handleRadios = el => {
        const radios = el.querySelectorAll('[data-radio]');
        radios.forEach(radio => {
           const input = radio.querySelector('input');
           input.addEventListener('input', () => {
               refreshRadiosUi(el);
           });
        });
    };
    
    const handleMixed = el => {
        el.querySelectorAll('[data-radio]').forEach(radio => {
            radio.addEventListener('input', () => {
                refreshLocationArea(el);
            });
        });

        const submitButton = el.querySelector("[data-filter-text-submit]");
        const input = el.querySelector('[data-radio-input]');
        
        if (input && submitButton) {
            const inputField = input.querySelector('input');

            input.addEventListener('input', () => {
                refreshLocationArea(el);
            });
            inputField.addEventListener("keyup", e => {
                if (e.keyCode === 13) {
                    submitButton.dispatchEvent(new Event("click"));
                }
            });
        }
    };
    
    return {
        initBlock,
        refreshUi
    };
})();
ControlBinders.register(`[data-filter-group]`, el => filterGroup.initBlock(el));